import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@kanos/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, failure } from './api.js';
import { currentPath, startSignIn } from './session.js';
/** A change at Keycloak; afterwards Keycloak brings the person back to this page. */
export function AccountButton({ intent, variant = 'secondary', children, }) {
    return (_jsx(Button, { variant: variant, size: "sm", onPress: () => startSignIn(currentPath(), intent), children: children }));
}
/** The own name, written to the sign-in of Kanos; the session shows it at once (ADR-058). */
export function useRenameSelf() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: async (body) => {
            const { error, response } = await api.PUT('/api/v1/me/name', { body });
            if (!response.ok)
                throw failure('renameSelf', error, response.status);
        },
        // The name shows wherever the person is named: everything is read anew.
        onSuccess: () => client.invalidateQueries(),
    });
}
/** A new own password, set after a fresh second factor (ADR-058). */
export function useChangeOwnPassword() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: async (body) => {
            const { error, response } = await api.PUT('/api/v1/me/password', { body });
            if (!response.ok)
                throw failure('changeOwnPassword', error, response.status);
        },
        onSuccess: () => client.invalidateQueries(),
    });
}
//# sourceMappingURL=own-account.js.map